import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import ReactTooltip from 'react-tooltip';

import Select from 'react-select';

import {
  getIcon,
  formatThousands,
  getOptionValueForSelect,
  dealAmountAsString,
  dealValueInUSD,
  getClassModifierForConfidence,
  getColorForCondifence,
} from '../../util';

import {
  localizeToString
} from '../../util/localizers';

import {
  UserAndTeamSelect,
  Localize,
  NumericalInput,
} from '../shared';

import {
  getDealCompletion
} from '../../util/dealScoring';

import {
  fetchDealsForEveryone
} from '../../actions/deals';

import {
  fetchUserDataForEveryone
} from '../../actions';

const REPORT_PERIOD_OPTIONS = [
  { label: 'All Open Deals', value: 'allOpen' },
  { label: 'This Quarter', value: 'thisQuarter' },
  { label: 'This Year', value: 'thisYear' },
  { label: 'Last Quarter', value: 'lastQuarter' },
  { label: 'Last Year', value: 'lastYear' },
];

const DEFAULT_DEAL_STAGES = [{
  label: 'Open',
  value: 'open',
  status: 'open',
},{
  label: 'Won',
  value: 'won',
  status: 'won',
},{
  label: 'Lost',
  value: 'lost',
  status: 'lost',
}];

class ForecastReport extends Component {

  state = {
    deals: null,
    userData: {},
    viewingTeam: 'everyone',
    viewingTeamUser: false,
    filters: {
      reportingPeriod: 'allOpen',
      stage: null,
      minValue: 0,
    },
    //sortByColumn: 'forecastedValue',
    sortByColumn: 'forecastedValue',
    sortDesc: true,
    showingMoreFilters: false,
  }

  componentDidMount(){
    this.props.fetchDealsForEveryone();
    this.props.fetchUserDataForEveryone(userData => {
      // console.log('found user data: ', userData);
      this.setState({
        userData: _.keyBy(userData, '_id')
      });
    }, true);
  }

  mapDealsToState(dealsToMap){

    const mapDeal = deal => {

      const completion = getDealCompletion(deal);
      const age = Math.max(Math.ceil(moment().diff(deal.createdOn.toDate(), 'days')), 1);
      const confidence = deal.status === 'won' ? 100 : (deal.status === 'lost' ? 0 : completion.confidence);

      return {
        ...deal,
        createdOnDate: deal.createdOn.toDate(),
        completion,
        confidence,
        age,
        valueInUSD: dealValueInUSD(deal),
        forecastedValue: Math.floor(dealValueInUSD(deal) * (confidence / 100.))
      }
    }

    const mappedDeals = _.map(dealsToMap, mapDeal);

    // console.log('mapped deals: ', mappedDeals);

    this.setState({
      deals: mappedDeals
    });
  }

  componentDidUpdate(prevProps){
    if(!prevProps.deals && this.props.deals){
      //map deals to state once...so we don't have to run computations multiple times for confidence etc.
      this.mapDealsToState(this.props.deals);
    }
  }

  userData(userId){
    return (this.state.userData || {})[userId];
  }
  teamData(teamId){
    const teamData = _.find(this.props.teams, { _id: this.state.viewingTeam });

    return teamData;
  }

  renderDealConfidence(deal){

    const { status, confidence } = deal;

    return (
      <div className="deal-confidence-bar-container">
        <div className="deal-confidence-progress">
          <div className={`deal-confidence-bar confidence-${getClassModifierForConfidence(confidence)} ${status}`} style={{width: `${status !== 'lost' ? confidence : 100}%`, backgroundColor: getColorForCondifence(confidence)}}></div>
        </div>
        {status === 'won' &&
          <div className="status-icon won">{getIcon('trophy')}</div>
        }
        {status === 'lost' &&
          <div className="status-icon lost">{getIcon('check-fail')}</div>
        }
      </div>
    )
  }

  activeColumns(){
    return [{
      id: 'name',
      label: 'Name',
      styles: { flex: 2 },
      render: (deal) => {
        return <Link to={`/deal/${deal._id}`} target="_blank">{deal.name}</Link>
      },
      sort: 'name'
    },{
      id: 'owner',
      label: 'Owner',
      render: (deal) => {
        const userId = deal.userId;
        const userData = this.userData(userId);

        if(userData){
          return <Link to={`/people/${userId}/imperatives`} target="_blank">{`${userData.firstName} ${userData.lastName}`}</Link>
        }
        else{
          return <span style={{opacity: .5}}>Unknown</span>;
        }
      },
      sort: (deal) => {
        const userId = deal.userId;
        const userData = this.userData(userId);

        if(!userData){ return ''; }

        return userData.firstName + userData.lastName;
      }
    },{
      id: 'age',
      label: 'Age',
      render: (deal) => {
        return `${deal.age} day${deal.age !== 1 ? 's' : ''}`;
      },
      sort: 'createdOnDate'
    },{
      id: 'close',
      label: 'Est Close',
      render: (deal) => {
        return moment(deal.estimatedCloseDate).format('M/D/YY');
      },
      sort: 'estimatedCloseDate'
    },{
      id: 'stage',
      label: 'Stage',
      render: (deal) => {
        return deal.stage;
      },
      sort: 'stage'
    },{
      id: 'confidence',
      label: 'Confidence',
      render: this.renderDealConfidence.bind(this),
      //sort: 'confidence'
      sort: deal => {
        return deal.confidence + (deal.status === 'won' && 100) + (deal.status === 'lost' && -100)
      }
    },{
      id: 'valueInUSD',
      label: <Localize id="report_label_deal_value">Value</Localize>,
      render: (deal) => {
        return dealAmountAsString(deal, true);
      },
      sort: 'valueInUSD'
      // sort: deal => {
      //   return deal.valueInUSD + (deal.status === 'won' && 100000000) + (deal.status === 'lost' && -100000000)
      // }
    },{
      id: 'forecastedValue',
      label: <Localize id="report_label_deal_forecasted">Forecasted</Localize>,
      render: (deal) => {
        if(deal.forecastedValue && deal.forecastedValue > 0){
          return `$${formatThousands(deal.forecastedValue)}`;
        }
        else{
          return '-'
        }
      },
      sort: 'forecastedValue'
      // sort: deal => {
      //   return deal.forecastedValue + (deal.status === 'won' && 100000000) + (deal.status === 'lost' && -100000000)
      // }
    }];
  }

  updateSortBy(columnId){

    const { sortDesc, sortByColumn } = this.state;
    const isSortingOnColumn = columnId === sortByColumn;

    if(isSortingOnColumn){
      this.setState({
        sortDesc: !sortDesc
      });
    }
    else{
      this.setState({
        sortByColumn: columnId
      });
    }
  }

  renderColumn(column){

    const { sortDesc, sortByColumn } = this.state;
    const isSortingOnColumn = column.id === sortByColumn;

    return (
      <div
        onClick={() => { this.updateSortBy(column.id); }}
        key={column.id}
        className={`row-item row-item-heading sortable ${isSortingOnColumn ? 'is-sorting ' : ''}`} style={column.styles || {}}>{column.label}<span className={`sort-toggle ${sortDesc ? 'sort-direction-desc' : ''}`}>{getIcon('sort')}</span></div>
    )
  }

  renderActiveColumns(){
    const activeColumns = this.activeColumns();

    return (
      <div className="sortable-list-row headings">
        {_.map(activeColumns, this.renderColumn.bind(this))}
      </div>
    )
  }

  renderReportRowItem(column, deal){
    return (
      <div key={`deal-${deal._id}-row-item-for-column-${column.id}`} className={`row-item row-status-${deal.status}`} style={column.styles || {}}>{column.render(deal)}</div>
    )
  }

  renderReportRow(deal){
    return (
      <div key={`row-for-deal-${deal._id}`} className="sortable-list-row">
        {_.map(this.activeColumns(), column => { return this.renderReportRowItem(column, deal); })}
      </div>
    )
  }

  filterDataByViewingTeamOrUsers(items){

    let filterByUserIds = null;

    if(this.state.viewingTeamUser){
      filterByUserIds = [this.state.viewingTeamUser];
    }
    else if(this.state.viewingTeam){
      const teamData = this.teamData(this.state.viewingTeam);

      if(teamData){
        filterByUserIds = [ ...teamData.leaders, ...teamData.members ];
      }
    }

    if(filterByUserIds){
      return _.filter(items, item => {
        return filterByUserIds.indexOf(item.userId) !== -1;
      });
    }
    else{
      return items;
    }
  }

  getSortedAndFilteredData(){
    const { filters, sortByColumn, sortDesc } = this.state;
    const { reportingPeriod, stage, minValue } = filters;

    //for now..just filter to open deals, and filter on employees/teams
    let filteredDeals = [];

    if(reportingPeriod === 'allOpen'){
      filteredDeals = _.filter(this.state.deals, deal => {
        return deal.status === 'open';
      });
    }
    else if(reportingPeriod === 'thisQuarter'){
      filteredDeals = _.filter(this.state.deals, deal => {
        return  moment(deal.estimatedCloseDate).utc().quarter() === moment().quarter() &&
                moment(deal.estimatedCloseDate).year() === moment().year();
      });
    }
    else if(reportingPeriod === 'thisYear'){
      filteredDeals = _.filter(this.state.deals, deal => {
        return moment(deal.estimatedCloseDate).year() === moment().year();
      });
    }
    else if(reportingPeriod === 'lastQuarter'){
      filteredDeals = _.filter(this.state.deals, deal => {
        return  moment(deal.estimatedCloseDate).utc().quarter() === moment().subtract(1, 'quarter').quarter() &&
                moment(deal.estimatedCloseDate).year() === moment().subtract(1, 'quarter').year();
      });
    }
    else if(reportingPeriod === 'lastYear'){
      filteredDeals = _.filter(this.state.deals, deal => {
        return moment(deal.estimatedCloseDate).year() === moment().subtract(1, 'years').year();
      });
    }

    if(stage){
      filteredDeals = _.filter(filteredDeals, deal => {
        return deal.stage === stage;
      });
    }

    if(minValue && minValue > 0){
      filteredDeals = _.filter(filteredDeals, deal => {
        return deal.estimatedValue && parseInt(deal.estimatedValue) > minValue;
      });
    }

    const filteredDealsByTeamAndUsers = this.filterDataByViewingTeamOrUsers(filteredDeals);

    const sortByColumnData = _.find(this.activeColumns(), { id: sortByColumn });
    const sortByFunction = sortByColumnData.sort;

    const sortedData = _.sortBy(filteredDealsByTeamAndUsers, sortByFunction);

    if(sortDesc){ sortedData.reverse(); }

    return sortedData;
  }

  renderReportRows(){
    return (
      <div className="sortable-list-data">
        {_.map(this.getSortedAndFilteredData(), this.renderReportRow.bind(this))}
      </div>
    )
  }

  renderReportTable(){

    //don't render if loading...
    if(!this.state.userData || !this.props.deals){
      return null;
    }

    return (
      <div className="sortable-list-view">
        {this.renderActiveColumns()}
        {this.renderReportRows()}
      </div>
    )
  }

  getTotalsForFilteredDeals(){
    const filteredAndSortedDeals = this.getSortedAndFilteredData();

    const dealCount = _.size(filteredAndSortedDeals);
    const averageAge = Math.ceil(_.meanBy(filteredAndSortedDeals, 'age'));

    const dealSum = _.sumBy(filteredAndSortedDeals, 'valueInUSD');
    const dealForecast = _.sumBy(filteredAndSortedDeals, 'forecastedValue');

    return {
      dealCount,
      averageAge,
      dealSum,
      dealForecast
    }
  }

  renderReportTotals(){

    const {
      dealCount,
      averageAge,
      dealSum,
      dealForecast,
    } = this.getTotalsForFilteredDeals();

    return (
      <div className="report-totals-container">
        <div className="report-totals">
          <div className="report-total">
            <div className="label">Total Deals</div>
            <div className="amount">{dealCount || '-'}</div>
          </div>
          <div className="report-total">
            <div className="label">Average Age</div>
            <div className="amount">{averageAge || '-'} days</div>
          </div>
          <div className="report-total">
            <div className="label">Active Pipeline</div>
            <div className="amount">${formatThousands(dealSum)}</div>
          </div>
          <div className="report-total">
            <div className="label">Velocity Pipeline</div>
            <div className="amount">${formatThousands(dealForecast)}</div>
          </div>
        </div>
      </div>
    )
  }

  viewUser(user){
    this.setState({
      viewingTeamUser: user,
    });
  }
  viewTeam(team){
    this.setState({
      viewingTeamUser: false,
      viewingTeam: team
    });
  }

  selectReportPeriod(period){
    this.setState({
      filters: {
        ...this.state.filters,
        reportingPeriod: period
      }
    });
  }

  renderReportPeriodSelect(){

    const currentReportPeriod = this.state.filters.reportingPeriod;

    return (
      <Select
        classNamePrefix={'react-select'}
        className='react-select-container period-select'
        value={getOptionValueForSelect(REPORT_PERIOD_OPTIONS, currentReportPeriod)}
        options={REPORT_PERIOD_OPTIONS}
        onChange={(option) => { this.selectReportPeriod(option.value) }}
        isSearchable={false}
      />
    )
  }

  getPageTitle(){
    const {
      viewingTeam,
      viewingTeamUser
    } = this.state;

    const userData = this.userData(viewingTeamUser);
    const teamData = this.teamData(this.state.viewingTeam);

    if(viewingTeamUser && userData){
      return <h1>Sales Forecast<span className="print-only">: {userData.firstName} {userData.lastName}</span></h1>;
    }
    else if(viewingTeam && teamData){
      return <h1>Sales Forecast<span className="print-only">: {teamData.name}</span></h1>;
    }
    else{
      return <h1>Sales Forecast</h1>;
    }
  }

  renderShowFilters(){
    if(this.state.showingMoreFilters){
      return null;
    }
    return (
      <div
        onClick={() => { this.setState({ showingMoreFilters: true }); }}
        className="show-filters">More filters</div>
    );
  }

  updateFilterValue(key, newValue){
    this.setState({
      filters: {
        ...this.state.filters,
        [key]: newValue
      }
    });
  }

  renderReportStageFilter(){

    const stages = this.props.organization && this.props.organization.dealStages || DEFAULT_DEAL_STAGES;

    const stageOptions = [
      {
        label: 'All deal stages',
        value: null
      },
      ...stages
    ];

    const { stage } = this.state.filters;

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container small-select ${stage ? 'has-value' : ''}`}
        value={getOptionValueForSelect(stageOptions, stage)}
        options={stageOptions}
        onChange={(option) => { this.updateFilterValue('stage', option.value); } }
      />
    )
  }

  renderReportMinValueFilter(){

    const {
      minValue
    } = this.state.filters;

    return (
      <NumericalInput
        className="value-filter"
        formatThousands={true}
        placeholder={'Minimum ' + localizeToString(this.props.activeLocalization, 'report_label_deal_value', 'Value')}
        value={minValue || ''}
        onUpdate={val => { this.updateFilterValue('minValue', val); }}
      />
    )
  }

  renderMoreFilters(){
    return (
      <div className="select-group second-row">
        {this.renderReportStageFilter()}
        {this.renderReportMinValueFilter()}
      </div>
    )
  }

  render(){

    return (
      <div className="report forecast">
        <div className="content-wrapper">
          <div className="page-main-content">
            <div className="page-title no-subheader">
              {this.getPageTitle()}
              <h3 className="print-only">{moment().format('M/D/YYYY')}</h3>
            </div>
            <div className="page-actions">
              <div className="select-group">
                {this.renderReportPeriodSelect()}
                <UserAndTeamSelect
                  teams={this.props.teams}
                  userData={this.state.userData}
                  viewingTeam={this.state.viewingTeam}
                  viewingTeamUser={this.state.viewingTeamUser}
                  viewUser={this.viewUser.bind(this)}
                  viewTeam={this.viewTeam.bind(this)}
                />
                {this.renderShowFilters()}
              </div>
              {this.state.showingMoreFilters && this.renderMoreFilters()}
            </div>
            <div className="page-content">
              {this.renderReportTotals()}
              {this.renderReportTable()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    teams: state.teams.data,
    deals: state.deals.data,
    fetchingAllDeals: state.deals.loading,
    organization: state.organization.data,
    activeLocalization: state.activeLocalization.data,
  }
}

export default connect(mapStateToProps, { fetchDealsForEveryone, fetchUserDataForEveryone })(ForecastReport);



// WEBPACK FOOTER //
// ./src/components/reports/forecast.js